import type { IMenuSection } from '@fondationcss/ui';

/**
 * Side menu, aligned with the pattern of Parcours' `frontend/src/sidebar-items.ts`:
 * the platform expects `Menus: IMenuSection[]` (sections containing `groups`), and
 * not the legacy `SidebarItems` list the fondation-sample-project template still
 * uses and which renders nothing.
 *
 * `module` + `permissions` mirror exactly what `DashboardModule` declares on the
 * server side (`MODULE_NAME` = `Scheduler.Dashboard`, `PERMISSION_ADMINISTRATOR` =
 * `Administrateur`). The scheduler is an operations tool: all its views are reserved
 * for the administrator, and the server decides anyway — every `/api/dashboard/**`
 * route answers 403 without that permission.
 */
const MODULE = 'Scheduler.Dashboard';
const ADMIN = `${MODULE}.Administrateur`;

export const menus: IMenuSection[] = [
  {
    title: 'Solveur',
    icon: 'gauge-high',
    iconOnly: true,
    maxGroups: 10,
    module: MODULE,
    permissions: [ADMIN],
    groups: [
      { title: 'Vue d’ensemble', icon: 'chart-simple', to: '/' },
      { title: 'Environnements', icon: 'server', to: '/environnements' },
      { title: 'Tous les jobs', icon: 'list-check', to: '/jobs' },
      { title: 'File en direct', icon: 'bolt', to: '/file' },
      { title: 'Comparaison', icon: 'chart-line', to: '/comparaison' },
      { title: 'Versions du solveur', icon: 'code-branch', to: '/versions' },
      { title: 'Locataires', icon: 'key', to: '/locataires' },
    ],
  },
];
